import { grey } from '@mui/material/colors';
import { colors } from '../colors';
export const Radio = {
  MuiRadio: {
    styleOverrides: {
      root: {
        width: '20px',
        height: '20px',
      },
    },
    variants: [
      {
        props: { variant: 'unchecked' },
        style: {
          border: `1px solid ${grey[400]}`,
          '&:hover': {
            border: `1px solid #156280`,
          },
        },
      },
      {
        props: { variant: 'checked' },
        style: {
          border: `1px solid ${colors.primary.main}`,
          '&:hover': {
            border: `1px solid #156280`,
          },
        },
      },
    ],
  },
};
